import { FC, useState, useEffect } from "react";
import { PageTitle } from "../../_private/layout/core";
import { useSelector, useDispatch } from "react-redux";
import { AppState, PROVIDERLIST } from "../../redux/types";
import { getDashboardData, getDashboardGamePlayGraphData, getDashboardWalletGraphData, getProviderList, getDashboardCategoryData, getDashboardProviderData, getDashboardTopGamesData, getDashboardClientData } from "../modules/auth/core/_requests";
import { useAuth } from "../modules/auth";
import { CardsWidget20 } from '../../../src/_private/partials/widgets/_new/cards/CardsWidget20';
import { KTIcon } from '../../../src/_private/helpers';
import DashboardChart from "../../_private/layout/components/custom/dashboardChart";
import DashboardBarChart from "../../_private/layout/components/custom/dashboardBarChart";
import LineChart from "../../_private/layout/components/custom/lineChart";
import './style.css';
import styles from './homeStyle.module.css';
import Select from 'react-select';
import { Link } from "react-router-dom";
import { Pagination } from "react-bootstrap";
const symbol = require("../../_private/assets/currency_symbol.json");

const COLORS = [
  "#1F77B4",  // Blue
  "#FF7F0E",  // Orange
  "#2CA02C",  // Green
  "#D62728",  // Dark Red
  "#9467BD",  // Purple
  "#8C564B",  // Brown
  "#E377C2",  // Pink
  "#7F7F7F",  // Gray
  "#BCBD22",  // Olive
  "#4A90E2",  // Soft Blue
  "#F5A623",  // Warm Orange
  "#7ED321",  // Bright Green
  "#D0021B",  // Bold Red
  "#9013FE",  // Rich Purple
  "#B8A18F",  // Muted Brown
  "#F8E71C",  // Light Yellow
  "#50E3C2",  // Mint
  "#417505"   // Forest Green
];

const ERR_COLOR = "#FF0000";

const PROVIDER_TABLE_PAGE = 1;
const PROVIDER_TABLE_LIMIT = 20;

const Dashboard: FC = () => {
  /* For triggring logout and dispatch and redirecting user */
  const { logout } = useAuth();
  const dispatch = useDispatch();

  // State to store the API response
  // const [data, setData] = useState<any>();
  const [data, setData] = useState<any>({
    "totalmonthbet": "0.00",
    "totalmonthwin": "0.00",
    "totaltodaybet": "0.00",
    "totaltodaywin": "0.00"
  });

  const [gameplayData, setGameplayData] = useState<any>([]);
  const [walletData, setWalletData] = useState<any>([]);
  const [clientGameplayData, setClientGameplayData] = useState<any>({ summary: [], count: 0, interval: 1 });

  const [dates, setDates] = useState<string[]>();

  const [loading, setLoading] = useState(false);
  //const [error, setError] = useState(null);

  // Client Game Play Filter States
  const [clientGameplayDateRange, setClientGameplayDateRange] = useState<any>({ value: 'today', label: 'Today', startDate: '', endDate: '' });
  const [clientGameplayType, setClientGameplayType] = useState<any>({ value: 'bet', label: 'BET' });
  const [providerDateRange, setProviderDateRange] = useState<any>({ value: 'lastThirtyDays', label: 'Last 30 Days', startDate: '', endDate: '' });
  const [providerData, setProviderData] = useState<any[]>([]);
  const [providerDataPage, setProviderDataPage] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const PROVIDER_ITEMS_PER_PAGE = 10;

  let currency = useSelector((state: AppState) => state.currencyCode);
  //console.log("currency => ", currency);

  let language = useSelector((state: AppState) => state.language);
  let token = useSelector((state: AppState) => state.token);
  // let currency = "KRW";
  let clientId = "";
  //let action = "";

  const fetchDashboardData = async (
    token: string,
    clientId: string,
    currentDate: string,
    start: string,
    end: string,
    currency: string
  ) => {
    try {
      const response = await getDashboardData(
        token,
        clientId,
        currentDate,
        start,
        end,
        currency
      );
      storeDataToSession(`summarydata_${currency}`, JSON.stringify(response.data.data));
      setData(response?.data?.data);
    } catch (error) { }
  };

  const fetchGameplayGraphData = async (
    token: string,
    startDate: string,
    endDate: string
  ) => {
    try {
      const response = await getDashboardGamePlayGraphData(
        token,
        startDate,
        endDate
      );
      setGameplayData(response?.data?.data);
    } catch (error) { }
  };

  const fetchWalletGraphData = async (
    token: string,
    startDate: string,
    endDate: string
  ) => {
    try {
      const response = await getDashboardWalletGraphData(
        token,
        startDate,
        endDate
      );
      setWalletData(response?.data?.data);
    } catch (error) { }
  };

  const fetchClientGameplayData = async (token: string, startDate: string, endDate: string, type: any) => {
    try {
      const response = await getDashboardClientData(token, startDate, endDate, currency, type.value);

      if (response?.data?.data?.clientData) {
        const clientData = response.data.data.clientData;
        // Filter out non-dataset objects (like extraTooltip metadata)
        const actualDatasets = clientData.datasets.filter((dataset: any) => dataset.data && Array.isArray(dataset.data));

        const transformedDatasets = actualDatasets.map(
          (dataset: any, index: number) => ({
            label: dataset.label,
            data: dataset.data,
            fill: false,
            borderColor: dataset.data.map(
              (_: any, i: number) => COLORS[i % COLORS.length],
            ),
            backgroundColor: dataset.data.map(
              (_: any, i: number) => COLORS[i % COLORS.length],
            ),
            tension: 0.4,
          }),
        );

        // Extract extra tooltip data from the datasets array
        const extraTooltipObj = clientData.datasets.find((dataset: any) => dataset.extraTooltipLabel && dataset.extraTooltipData);
        const extraTooltipLabel = extraTooltipObj?.extraTooltipLabel || 'Total bet count';
        const extraTooltip = extraTooltipObj?.extraTooltipData || [];

        const transformedData = {
          summary: transformedDatasets,
          labels: clientData.labels || [],
          count: clientData.labels?.length || 0,
          interval: 1,
          extraTooltipLabel,
          extraTooltip
        };
        setClientGameplayData(transformedData);
      }
    } catch (error) { }
  };

  let loding = async () => {
    try {
      setLoading(true);
      let dates = await getRequiredDates();
      //console.log("dates  ==> ", dates);
      await fetchDashboardData(
        token,
        clientId,
        dates.today,
        dates.startOfMonth,
        dates.endOfMonth,
        currency
      );

      setLoading(false);
      //console.log("symbol => ", symbol);
    } catch (error) { }
  };

  useEffect(() => {
    let storedData = getDataFromSession(`summarydata_${currency}`);
    try {
      storedData = JSON.parse(storedData);
    } catch (error) {
      loding();
    }
    if (storedData) {
      setData(storedData);
    }
    else {
      loding();
    }
  }, [currency]);

  useEffect(() => {
    if (clientGameplayDateRange.startDate && clientGameplayDateRange.endDate) {
      fetchClientGameplayData(token, clientGameplayDateRange.startDate, clientGameplayDateRange.endDate, clientGameplayType);
    }
  }, [currency, clientGameplayDateRange.startDate, clientGameplayDateRange.endDate, clientGameplayType.value, token]);

  // Initialize Client Game Play data on mount
  useEffect(() => {
    const dateRange = getDateRange('today');
    setClientGameplayDateRange(prev => ({ ...prev, startDate: dateRange.startDate, endDate: dateRange.endDate }));
  }, []);

  let providerList = useSelector((state: AppState) => state.providerList);

  const [providers, setProviders] = useState(providerList);

  const [provider, setProvider] = useState<any>();
  const [categoryData, setCategoryData] = useState<any>(
    {
      "labels": [
        "Live Casino",
        "Slots"
      ],
      "datasets": [
        {
          "label": "Total Margin",
          "data": [
            0,
            0
          ],
          "backgroundColor": [
            "#1F77B4",
            "#FF7F0E"
          ]
        }
      ]
    }
  );
  const [topGames, setTopGames] = useState<any>([]);

  // Client Game Play Options
  const clientGameplayTypeOptions = [
    { value: 'bet', label: 'BET' },
    { value: 'win', label: 'WIN' },
    { value: 'margin', label: 'MARGIN' }
  ];

  const getDateRange = (rangeType: string) => {
    const today = new Date();
    let startDate, endDate;

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    endDate = formatDate(today);

    switch (rangeType) {
      case 'today':
        startDate = formatDate(today);
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        startDate = formatDate(yesterday);
        endDate = formatDate(yesterday);
        break;
      case 'lastSevenDays':
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        startDate = formatDate(sevenDaysAgo);
        break;
      case 'lastThirtyDays':
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 30);
        startDate = formatDate(thirtyDaysAgo);
        break;
      default:
        startDate = formatDate(today);
    }

    return { startDate, endDate };
  };

  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'lastSevenDays', label: 'Last 7 Days' },
    { value: 'lastThirtyDays', label: 'Last 30 Days' }
  ];

  /* Function for Fetch Provider and Provider Category */
  const fetchProvider = async (token) => {
    try {

      const response = await getProviderList(token, "", "", 1, 50);
      const data = response?.data?.data?.provider_list;

      const providerListFilteredData = await data.map((item: any) => {
        return {
          providerId: item.provider_id,
          providerName: item?.provider_name?.[language.lang] || item?.game_provider_name?.en || "--",
        };
      });
      dispatch({
        type: PROVIDERLIST,
        payload: providerListFilteredData,
      });
      setProvider(providerListFilteredData[0]);
      setProviders(providerListFilteredData);

      //console.log('provider1', providerListFilteredData[0]);


      return providerList;
    } catch (error: any) {


      if (error?.request?.status === "403") {
        logout();
      }
      dispatch({
        type: PROVIDERLIST,
        payload: [],
      });
    }
  };

  const handleProviderChange = (provider) => {
    setProvider(provider);
    fetchTopGamesData(token, dates[0], dates[1], provider?.providerId);
  }

  const handleClientGameplayDateChange = (option) => {
    const dateRange = getDateRange(option.value);
    setClientGameplayDateRange({ ...option, ...dateRange });
  }

  const handleClientGameplayTypeChange = (option) => {
    setClientGameplayType(option);
  }

  const handleProviderDateRangeChange = async (option) => {
    setProviderDataPage(1);
    const dateRange = getDateRange(option.value);
    setProviderDateRange({ ...option, ...dateRange });
    await fetchProviderData(token, dateRange.startDate, dateRange.endDate, 1, PROVIDER_ITEMS_PER_PAGE);
  }

  const getPaginatedProviderData = () => {
    return providerData;
  };

  const handleProviderPageChange = async (page: number) => {
    if (page < 1 || page > totalPages) {
      return;
    }
    setProviderDataPage(page);
    const dateRange = getDateRange(providerDateRange.value);
    await fetchProviderData(token, dateRange.startDate, dateRange.endDate, page, PROVIDER_ITEMS_PER_PAGE);
  };

  const renderProviderPaginationItems = () => {
    const buttons = [];
    const maxVisiblePages = 2;

    if (totalPages <= 1) {
      if (totalPages === 1) {
        buttons.push(
          <Pagination.Item key={1} active>
            1
          </Pagination.Item>
        );
      }
      return buttons;
    }

    if (providerDataPage > maxVisiblePages + 2) {
      buttons.push(
        <Pagination.Item key={1} onClick={() => handleProviderPageChange(1)}>
          1
        </Pagination.Item>
      );
      buttons.push(<Pagination.Ellipsis key="ellipses-left" />);
    }

    for (let page = Math.max(1, providerDataPage - maxVisiblePages); page <= Math.min(totalPages, providerDataPage + maxVisiblePages); page++) {
      buttons.push(
        <Pagination.Item
          key={page}
          active={page === providerDataPage}
          onClick={() => handleProviderPageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    if (providerDataPage < totalPages - maxVisiblePages - 1) {
      buttons.push(<Pagination.Ellipsis key="ellipses-right" />);
      buttons.push(
        <Pagination.Item key={totalPages} onClick={() => handleProviderPageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return buttons;
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const fetchCategoryData = async (token, start_date, end_date) => {
    try {
      const response = await getDashboardCategoryData(token, start_date, end_date, currency);
      const data = response?.data?.data?.categoryData;
      const message = response?.data?.msg;

      if (response.status === 200) {

        let dataset = data?.datasets[0] || {};
        dataset.backgroundColor = [];

        for (let index = 0; index < dataset?.data?.length || 0; index++) {
          const element = dataset.data[index];
          if (element >= 0) {
            dataset.backgroundColor.push(COLORS[index]);
          }
          else {
            dataset.backgroundColor.push(ERR_COLOR);
          }
          data.datasets = [dataset];
        }


        setCategoryData(data);
      }
      else {
        console.log(`Error in categoryData : `, message);

      }
    } catch (error: any) {
      console.log(`Error in categoryData : `, error.message);
      if (error?.request?.status === "403") {
        logout();
      }
      dispatch({
        type: PROVIDERLIST,
        payload: [],
      });
    }

  }

  const fetchTopGamesData = async (token, start_date, end_date, provider_id) => {
    try {
      //console.log(`provider `, provider_id);
      const response = await getDashboardTopGamesData(token, start_date, end_date, currency, provider_id);
      let data = response?.data?.data?.gameData;

      data = data.slice(0, data.length);
      const message = response?.data?.msg;
      if (response.status === 200) {

        if (data.length > 0) {
          for (let index = 0; index < data.length; index++) {
            if (!data[index]) {
              data.push({ err: 0 });
            }
          }
        }

        await setTopGames(data);
      }
      else {
        console.log(`Error in categoryData : `, message);

      }
    } catch (error: any) {

      if (error?.request?.status === "403") {
        logout();
      }
      dispatch({
        type: PROVIDERLIST,
        payload: [],
      });
    }
  }

  const fetchProviderData = async (token, start_date, end_date, page = PROVIDER_TABLE_PAGE, limit = PROVIDER_TABLE_LIMIT) => {
    try {
      const response = await getDashboardProviderData(token, start_date, end_date, currency, page, limit);
      const payload = response?.data?.data;
      const message = response?.data?.msg;

      if (response.status === 200) {
        setProviderData(payload?.data || []);
        setTotalPages(payload?.pagination?.total_pages || 1);
        setProviderDataPage(page);
      } else {
        console.log(`Error in providerData : `, message);
      }
    } catch (error: any) {
      if (error?.request?.status === "403") {
        logout();
      }
      dispatch({
        type: PROVIDERLIST,
        payload: [],
      });
    }
  }

  useEffect(() => {

    (async function () {

      await fetchProvider(token);

      let dates = (function getTodayAndMonthAgo() {
        const today = new Date();

        // Clone the today date to avoid mutating the original
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(today.getMonth() - 1);

        // Helper function to format the date as 'DD/MM'
        function formatDate(date) {
          const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
          const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
        }

        // Return an array with the formatted dates of today and one month ago
        return [formatDate(oneMonthAgo), formatDate(today)];
      })();

      setDates(dates);

      getRequiredDates();


      await fetchCategoryData(token, dates[0], dates[1]);

      const providerSummaryDateRange = getDateRange('lastThirtyDays');
      setProviderDateRange(prev => ({ ...prev, ...providerSummaryDateRange }));
      await fetchProviderData(token, providerSummaryDateRange.startDate, providerSummaryDateRange.endDate, PROVIDER_TABLE_PAGE, PROVIDER_ITEMS_PER_PAGE);

      fetchGameplayGraphData(token, dates[0], dates[1]);
      fetchWalletGraphData(token, dates[0], dates[1]);

      let storedData = getDataFromSession(`summarydata_${currency}`);
      try {
        storedData = JSON.parse(storedData);
      } catch (error) {
        loding();
      }
      if (storedData) {
        setData(storedData);
      }
      else {
        loding();
      }
    })();

  }, [currency]);

  // this effect for top games
  useEffect(() => {
    let dates = (function getTodayAndMonthAgo() {
      const today = new Date();
      // Clone the today date to avoid mutating the original
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(today.getMonth() - 1);
      // Helper function to format the date as 'DD/MM'
      function formatDate(date) {
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      }
      // Return an array with the formatted dates of today and one month ago
      return [formatDate(oneMonthAgo), formatDate(today)];
    })();
    if (provider?.providerId) {
      fetchTopGamesData(token, dates[0], dates[1], providers?.[0]?.providerId);
    }
  }, [provider?.providerId]);

  let getRequiredDates = async () => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    const endOfMonth = new Date(nextMonth.getTime() - 1); // Use getTime() to get the timestamp

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    return {
      today: formatDate(today),
      startOfMonth: formatDate(startOfMonth),
      endOfMonth: formatDate(endOfMonth),
    };
  };

  const refreshData = async (e) => {
    loding();
  }


  const storeDataToSession = (key, value) => {
    window.sessionStorage.setItem(key, value);
  }

  const getDataFromSession = (key) => {
    return window.sessionStorage.getItem(key);
  }

  const amount_format = (num) => {
    if (
      num === "--" ||
      num === null ||
      num === undefined ||
      isNaN(Number(num.toString().replace(/,/g, "")))
    ) {
      return "--";
    }

    return Number(num.toString().replace(/,/g, "")).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const compactAmountFormat = (num) => {
    if (num === "--" || num === null || num === undefined || isNaN(Number(num.toString().replace(/,/g, "")))) {
      return "--";
    }

    const value = Number(num.toString().replace(/,/g, ""));
    const absolute = Math.abs(value);
    const suffix = value < 0 ? "-" : "";

    if (absolute >= 1_000_000_000_000) {
      return `${suffix}${(absolute / 1_000_000_000_000).toFixed(2).replace(/\.00$/, "")}T`;
    }
    if (absolute >= 1_000_000_000) {
      return `${suffix}${(absolute / 1_000_000_000).toFixed(2).replace(/\.00$/, "")}B`;
    }
    if (absolute >= 1_000_000) {
      return `${suffix}${(absolute / 1_000_000).toFixed(2).replace(/\.00$/, "")}M`;
    }
    if (absolute >= 1_000) {
      return `${suffix}${(absolute / 1_000).toFixed(2).replace(/\.00$/, "")}K`;
    }

    return `${suffix}${absolute.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <>
      <PageTitle breadcrumbs={[{ title: 'Home', path: '', isActive: true }]}>DASHBOARD</PageTitle>
      <span className={`menu-icon refresh-btn ${loading ? 'rotate-refresh' : ''}`} onClick={refreshData}>
        <KTIcon iconName={'arrows-circle'} iconType='outline' className='fs-1' />
      </span>
      <div className="card pt-9">
        <div className="card-body p-0">
          <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
              <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                <div className="col-md-6 col-lg-3 col-xl-3 col-xxl-3">
                  <CardsWidget20 className="" description="Total Today BET" color="#3d3d3d" img="linear-gradient(90deg, rgba(253,97,2,1) 0%, rgba(239,155,89,1) 100%)" number={amount_format(data?.totaltodaybet || 0)} symbol={symbol[currency]} />

                </div>

                <div className="col-md-6 col-lg-3 col-xl-3 col-xxl-3">
                  <CardsWidget20 className="" description="Total Today WIN" color="#3d3d3d" img="linear-gradient(90deg, #ecb002, #ffd046)" number={amount_format(data?.totaltodaywin)} symbol={symbol[currency]} />
                </div>

                <div className="col-md-6 col-lg-3 col-xl-3 col-xxl-3">
                  <CardsWidget20 className="" description="Total Monthly BET" color="#3d3d3d" img="linear-gradient(90deg, #003eaf, #328eff)" number={amount_format(data?.totalmonthbet)} symbol={symbol[currency]} />
                </div>

                <div className="col-md-6 col-lg-3 col-xl-3 col-xxl-3">
                  <CardsWidget20 className="" description="Total Monthly WIN" color="#3d3d3d" img="linear-gradient(90deg, #418901, #9ed438)" number={amount_format(data?.totalmonthwin)} symbol={symbol[currency]} />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <div className="card my-5">
            <div className="card-body p-3" style={{ minHeight: '350px', width: '100%' }}>
              {categoryData?.datasets?.[0]?.data.length > 0 ? (
                <DashboardBarChart categoryData={categoryData} />
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="card my-5">
            <div className="card-header py-3 px-4 d-flex justify-content-between align-items-center flex-wrap">
              <h5 className="card-title mb-0">Provider Summary</h5>
              <div style={{ minWidth: '140px', maxWidth: '140px' }}>
                <Select
                  value={providerDateRange}
                  options={dateRangeOptions}
                  className={styles['goodSelect'] + " " + styles['p-1'] + " goodSelect"}
                  isSearchable={false}
                  onChange={handleProviderDateRangeChange}
                />
              </div>
            </div>

            <div className="card-body p-3" style={{ minHeight: '400px', width: '100%', display: 'flex', flexDirection: 'column' }}>
              {providerData?.length > 0 ? (
                <div className="table-responsive" style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative', paddingBottom: '48px' }}>
                  <table className="table table-striped table-bordered table-hover mb-0">
                    <thead>
                      <tr>
                        <th>Provider</th>
                        <th className="text-end">Bet</th>
                        <th className="text-end">Win</th>
                        <th className="text-end">Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPaginatedProviderData().map((provider, index) => (
                        <tr key={provider?.provider_id || index}>
                          <td style={{ fontSize: '0.85rem' }}>{provider?.provider_name || '--'}</td>
                          <td className="text-end" style={{ fontSize: '0.95rem' }} title={amount_format(provider?.total_bet)}>{compactAmountFormat(provider?.total_bet)}</td>
                          <td className="text-end" style={{ fontSize: '0.95rem' }} title={amount_format(provider?.total_win)}>{compactAmountFormat(provider?.total_win)}</td>
                          <td className="text-end" style={{ fontSize: '0.95rem`' }} title={amount_format(provider?.total_margin)}>{compactAmountFormat(provider?.total_margin)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className='dataTables_paginate paging_simple_numbers' id='kt_datatable_example_1_paginate' style={{ position: 'absolute', bottom: 0, right: 0 }}>
                    <Pagination className='mb-0' style={{ fontSize: '0.95rem' }}>
                      <Pagination.Prev
                        onClick={() => handleProviderPageChange(providerDataPage - 1)}
                        disabled={providerDataPage === 1 || totalPages <= 1}
                      />
                      {renderProviderPaginationItems()}
                      <Pagination.Next
                        onClick={() => handleProviderPageChange(providerDataPage + 1)}
                        disabled={providerDataPage === totalPages || totalPages <= 1}
                      />
                    </Pagination>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center" style={{ flex: 1 }}>
                  <p className="text-muted mb-0">No provider data available</p>
                </div>
              )}
            </div>

          </div>
        </div>

        <div className="col-sm-8 mt-5">
          <div className="card card-custom card-stretch gutter-b" style={{ minHeight: "calc(100% - 16px)" }}>
            {/* begin::Header */}
            <div className="card-header border-0 py-5">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label font-weight-bolder text-dark">{"Top 10 Games This Month".toUpperCase()}</span>
              </h3>
              <div className="card-toolbar align-items-start">
                <Link to='#' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end' data-kt-menu-flip='top-end' className={styles['font-weight-bolder'] + " " + styles['d-block'] + " " + styles['font-size-md'] + " " + styles['text-primary']}>
                  {provider?.providerName}
                  <span className='svg-icon fs-5 m-0'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24px' height='24px' viewBox='0 0 24 24' version='1.1'>
                      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                        <polygon points='0 0 24 0 24 24 0 24'></polygon>
                        <path
                          d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
                          fill='currentColor'
                          fillRule='nonzero'
                          transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'></path>
                      </g>
                    </svg>
                  </span>
                </Link>
                <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fs-7 w-225px py-4 text-dark-50 max-h-[300px] overflow-y-auto' data-kt-menu='true' style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {/* <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fs-7 w-225px py-4 text-dark-50' data-kt-menu='true'> */}
                  {providers.length > 0 ? (
                    providers.map((provider) => (
                      <div className='menu-item px-2 ' key={provider?.providerId}>
                        <Link to={"#"} className='menu-link px-3' data-kt-docs-table-filter='edit_row'
                          onClick={() => { handleProviderChange(provider) }}>
                          {provider.providerName}
                        </Link>
                      </div>
                    ))
                  ) : (
                    <div className='menu-item px-2 ' key={1}>
                      <Link to={"#"} className='menu-link px-3' data-kt-docs-table-filter='edit_row'>
                        No Provider Found
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* end::Header */}

            {/* begin::Body */}
            <div className="card-body" style={{ padding: '1rem' }}>
              <div className="tab-content">
                {/* begin::Table */}

                <div className="table-responsive">
                  <table className="table table-striped table-borderless table-vertical-center">
                    <thead className="px-3">
                      <tr className="text-left px-3 text-uppercase">
                        <th className="px-3 text-dark-50-top-games" style={{ minWidth: '40px' }}>#</th>
                        <th style={{ minWidth: '250px', textAlign: 'center' }} className="pl-7 px-3">
                          <span className="text-dark-50-top-games">Game</span>
                        </th>
                        <th style={{ minWidth: '100px', textAlign: 'end' }} className="px-3 text-dark-50-top-games">Total Bet</th>
                        <th style={{ minWidth: '100px', textAlign: 'end' }} className="px-3 text-dark-50-top-games">Total Win</th>
                        <th style={{ minWidth: '100px', textAlign: 'end' }} className="px-3 text-dark-50-top-games">Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topGames.length > 0 ? (
                        topGames.map((game, index) => (
                          (!game.err) ? (
                            <tr className="border-bottom">
                              <td className="align-middle py-2">
                                <span className="font-weight-bolder d-block font-size-lg text-dark-50">{index + 1}</span>
                              </td>
                              <td className="py-2">
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-50 symbol-light mr-4">
                                    <span className="symbol-label symbol-2by3">
                                      <img src={game?.game_image} className="h-100 align-self-end me-5" alt="" style={{ borderRadius: '5px' }} />
                                    </span>
                                  </div>
                                  <div className="ms-5">
                                    <a href="#" className="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{game?.game_name?.[language.lang] || game?.game_name?.en || ""}</a>
                                    <span className="text-muted font-weight-bold d-block">{game.category_name?.[language.lang] || game.category_name?.en || ""}</span>
                                  </div>
                                </div>
                              </td>
                              <td className="align-middle py-2 text-align-right">
                                <span className="text-dark-50 font-weight-bolder d-block font-size-lg float-end">{symbol[currency] + " " + (game?.bet) ? game.bet : "0.00"}</span>
                              </td>
                              <td className="align-middle py-2 text-align-right">
                                <span className="text-dark-50 font-weight-bolder d-block font-size-lg float-end">{symbol[currency] + " " + (game?.win) ? game.win : "0.00"}</span>
                              </td>
                              <td className="align-middle py-2 text-align-right">
                                <span className="text-dark-50 font-weight-bolder d-block font-size-lg float-end">{symbol[currency] + " " + (game?.margin) ? game?.margin : "0.00"}</span>
                              </td>
                            </tr>
                          ) : (
                            <tr className="border-bottom">
                              <td className="align-middle py-2">
                                <span className="font-weight-bolder d-block font-size-lg text-dark-50">{index + 1}</span>
                              </td>
                              <td className="py-2">
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-50 symbol-light mr-4">
                                    <span className="symbol-label">

                                    </span>
                                  </div>
                                  <div className="ms-5">
                                    --
                                  </div>
                                </div>
                              </td>
                              <td className="align-middle py-2 text-align-center">
                                --
                              </td>
                              <td className="align-middle py-2 text-align-center">
                                --
                              </td>
                              <td className="align-middle py-2 text-align-center">
                                --
                              </td>
                            </tr>
                          )
                        ))
                      ) : (
                        <tr className="border-bottom">
                          <td className="align-middle text-align-center py-0" colSpan={5}>
                            You have no game of this provider.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* end::Table */}
              </div>
            </div>
            {/* end::Body */}
          </div>

        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <div className="card my-5">
            <div className="card-body p-3">
              <DashboardChart gameplayData={gameplayData} header="Monthly Gameplay Transaction" />
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="card my-5">
            <div className="card-body p-3">
              <DashboardChart gameplayData={walletData} header="Monthly Wallet Transaction" />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card my-5">
            <div className="card-header border-0 py-3 px-5 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
              <div>
                <h3 className="card-title mb-2 mb-md-0">
                  <span className="card-label font-weight-bolder text-dark">{"Client Gameplay Overview".toUpperCase()}</span>
                </h3>
              </div>
              <div className="d-flex flex-column flex-sm-row gap-3 w-100 w-md-auto align-items-stretch align-items-sm-end">
                <div className="flex-grow-1 flex-sm-grow-0" style={{ minWidth: '180px' }}>
                  {/* <label className="form-label">Date Range<span className='text-danger px-2'>*</span></label> */}
                  <label className="form-label"><span className='text-danger px-2'></span></label>
                  <Select
                    value={clientGameplayDateRange}
                    options={dateRangeOptions}
                    className={styles['goodSelect'] + " " + styles['p-1'] + " goodSelect"}
                    isSearchable={false}
                    onChange={handleClientGameplayDateChange}
                  />
                </div>
                <div className="flex-grow-1 flex-sm-grow-0" style={{ minWidth: '180px' }}>
                  {/* <label className="form-label">Type<span className='text-danger px-2'>*</span></label> */}
                  <label className="form-label"><span className='text-danger px-2'></span></label>
                  <Select
                    value={clientGameplayType}
                    options={clientGameplayTypeOptions}
                    className={styles['goodSelect'] + " " + styles['p-1'] + " goodSelect"}
                    isSearchable={false}
                    onChange={handleClientGameplayTypeChange}
                  />
                </div>
              </div>
            </div>

            <div className="card-body px-4 py-3">
              {clientGameplayData?.summary?.length > 0 ? (
                <LineChart gameplayData={clientGameplayData} header="Client Game Play" />
              ) : (
                <div className="d-flex align-items-center justify-content-center" style={{ height: '260px' }}>
                  <p className="text-muted mb-0">No data available for the selected filters</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export { Dashboard };
